export default __webpack_public_path__ + "ed1f3c3132fd87a65b03a1936efd5aac.png";